var _Path, _Circle, _Line, _Line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path, Circle, Line } from "react-native-svg";
var SvgUserPlus = function SvgUserPlus(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-user-plus"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
  })), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 8.5,
    cy: 7,
    r: 4
  })), _Line || (_Line = /*#__PURE__*/React.createElement(Line, {
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 14
  })), _Line2 || (_Line2 = /*#__PURE__*/React.createElement(Line, {
    x1: 23,
    y1: 11,
    x2: 17,
    y2: 11
  })));
};
export default SvgUserPlus;